class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    // HLA: on hover-capable (desktop) devices, open the dropdown on
    // hover/keyboard-focus and let a click on the top-level item navigate to
    // its collection (data-href) instead of just toggling. Touch / no-hover
    // devices keep Dawn's default tap-to-toggle behavior so the menu stays
    // reachable without a hover state.
    this.supportsHover =
      window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (this.supportsHover) {
      this.addEventListener('pointerenter', this.open.bind(this));
      this.addEventListener('pointerleave', this.close.bind(this));
      this.addEventListener('focusin', this.open.bind(this));
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  open() {
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  onSummaryClick(event) {
    const href = this.summary.dataset.href;
    if (!href || href === '#') return; // no destination → fall back to toggle
    event.preventDefault();
    window.location.href = href;
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
